export default __webpack_public_path__ + "static/tank_scaled-ed35d017750ce6699999b1f222ea40d7.gif";